import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ReportDropDown, ReportDropDownList } from "src/app/models/reports";

@Component({
    selector: 'mwp-report-builder-intialize',
    templateUrl: './report-builder-intialize.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportBuilderIntializeComponent implements OnInit {
    @Input() reportsList: ReportDropDownList;

    @Output() public emitSave: EventEmitter<number> = new EventEmitter();

    public companyReports: ReportDropDown[];
    public fieldAgentReports: ReportDropDown[];
    public supervisorReports: ReportDropDown[];
    public administratorReports: ReportDropDown[];

    public companyForm: FormGroup;
    public fieldAgentForm: FormGroup;
    public supervisorForm: FormGroup;
    public administratorForm: FormGroup;

    private reportIdField: string = 'reportID';

    constructor(
        private formBuilder: FormBuilder,
    ) {
        this.companyForm = this.formBuilder.group({
            [this.reportIdField]: [null, Validators.required],
        });
        this.fieldAgentForm = this.formBuilder.group({
            [this.reportIdField]: [null, Validators.required],
        });
        this.supervisorForm = this.formBuilder.group({
            [this.reportIdField]: [null, Validators.required],
        });
        this.administratorForm = this.formBuilder.group({
            [this.reportIdField]: [null, Validators.required],
        });
    }

    ngOnInit(): void {
        this.companyReports = this.reportsList.companyReports;
        this.fieldAgentReports = this.reportsList.fieldAgentReports;
        this.supervisorReports = this.reportsList.supervisorReports;
        this.administratorReports = this.reportsList.administratorReports;
    }

    public runReport(form: FormGroup): void {
        this.emitSave.emit(form.get(this.reportIdField).value);
    }

}